import { Component } from '@angular/core';

/** The google logo */
@Component({
  selector: 'io-provetech-google-logo',
  templateUrl: '../../assets/google-logo.svg',
  styles: ['']
})
export class GoogleLogoSvg {}
